/**
 * 家族（兄弟）の利用可否（GET /api/family-membership）の判定。指示書 B「子ども単位の契約判定」。
 * サーバーの判定（/api/learner-membership-status と共通）を、そのまま使う。画面側で契約の解釈を足さない。
 */

/**
 * API の応答を分類する。2xx 以外・形が違う応答は「取得できなかった」（未契約と扱わない）。
 * @returns {{ kind: 'ok', family: { any_access: boolean, learners: object[] } } | { kind: 'error' }}
 */
export function classifyFamilyResponse({ ok, json }) {
  if (!ok) return { kind: 'error' }
  if (!json || typeof json !== 'object' || !Array.isArray(json.learners) || typeof json.any_access !== 'boolean') {
    return { kind: 'error' }
  }
  return { kind: 'ok', family: json }
}

/**
 * 選んでいる学習者で、トップに入れるか。
 *   allowed     選んでいる子は利用できる
 *   switch      選んでいる子は利用できないが、利用できる兄弟がいる（切り替えのボタンを出す。勝手に切り替えない）
 *   denied_all  誰も利用できない（マイページへ案内）
 *   unknown     選んでいる子が家族の一覧に無い（読み直しが必要。未契約とは扱わない）
 */
export function decideLearnerEntry({ family, selectedLearnerId }) {
  const learners = family?.learners || []
  const selected = learners.find((l) => l.learner_id === selectedLearnerId)
  if (!selected) return { kind: 'unknown' }
  if (selected.can_access) return { kind: 'allowed', selected }
  const candidates = learners.filter((l) => l.can_access && l.learner_id !== selectedLearnerId)
  if (candidates.length > 0) return { kind: 'switch', selected, candidates }
  return { kind: 'denied_all', selected }
}

/** 切り替えの案内の文 */
export function switchNoticeText(selected) {
  const name = (selected?.name || '').trim()
  const who = name ? `${name}さん` : '選択中のお子さま'
  return `${who}は、現在ご利用いただけません（ご契約・体験の期間が終了しています）。利用できるお子さまに切り替えてください。`
}
